var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Grid, Progress } from 'semantic-ui-react';
import Button from 'components/Button/Button';
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import BackupIcon from 'components/Icons/BackupIcon';
import DownloadIcon from 'components/Icons/DownloadIcon';
import { showModal } from '../../../../actions/modalActions';
import apis from '../../../../apis/index';
import styleConstants from '../../../../assets/styles/style-constants';
var SandboxBackups = function (props) {
    var _this = this;
    var data = props.data, accessToken = props.accessToken;
    var sandboxHashKey = data.sandboxHashKey;
    var statusKey = "BackupStatus-".concat(sandboxHashKey);
    var backupLinkStoreName = "BackupLinkStore-".concat(sandboxHashKey);
    var _a = useState(false), isLoading = _a[0], setIsLoading = _a[1];
    var _b = useState(false), isRequestDisabled = _b[0], setIsRequestDisabled = _b[1];
    var _c = useState(function () {
        var item = localStorage.getItem(statusKey);
        if (!item) {
            return false;
        }
        var status = JSON.parse(item).status;
        return status == 'SUCCESS';
    }), isRequestSuccess = _c[0], setIsRequestSuccess = _c[1];
    var _d = useState(function () {
        var item = localStorage.getItem(statusKey);
        if (!item) {
            return false;
        }
        var status = JSON.parse(item).status;
        console.log(item);
        return status === 'PENDING';
    }), isRequestPending = _d[0], setIsRequestPending = _d[1];
    var _e = useState(function () {
        var item = localStorage.getItem(statusKey);
        if (!item) {
            return false;
        }
        var status = JSON.parse(item).status;
        return status == 'FAILED';
    }), didRequestFail = _e[0], setDidRequestFail = _e[1];
    var _f = useState(0), backoff = _f[0], setBackoff = _f[1];
    var _g = useState([]), backups = _g[0], setBackups = _g[1];
    var _h = useState(true), backupsShouldUpdate = _h[0], setBackupsShouldUpdate = _h[1];
    var _j = useState(React.createElement("div", null)), backupList = _j[0], setBackupList = _j[1];
    var _k = useState(function () {
        var item = localStorage.getItem(backupLinkStoreName);
        if (!item) {
            return {};
        }
        return JSON.parse(item);
    }), backupLinkStore = _k[0], setBackupLinkStore = _k[1];
    useEffect(function () {
        function fetchData() {
            return __awaiter(this, void 0, void 0, function () {
                var _a, err, data, expanded;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0: return [4 /*yield*/, apis.sandbox.getBackupsByHash(accessToken, sandboxHashKey)];
                        case 1:
                            _a = _b.sent(), err = _a[0], data = _a[1];
                            if (!err) {
                                expanded = data.data.map(expandDate);
                                setBackups(expanded);
                                setBackupsShouldUpdate(false);
                                setBackupList(expanded.map(function (row, index) { return BackupRow(row, index); }));
                            }
                            else {
                                console.error('Something went wrong fetching backups');
                            }
                            setIsLoading(false);
                            return [2 /*return*/];
                    }
                });
            });
        }
        if (isLoading == false) {
            setIsLoading(true);
            fetchData();
        }
    }, [backupsShouldUpdate]);
    var onExtend = function () {
        props.showActionModal({
            type: 'extend',
            data: __assign(__assign({}, data), { clickedFrom: 'settings' }),
        });
    };
    var expandDate = function (obj) {
        obj.date = new Date(obj.LastModified);
        obj.date_locale = obj.date.toLocaleString();
        obj.date_utc = obj.date.toUTCString();
        return obj;
    };
    var checkProgress = function () { return __awaiter(_this, void 0, void 0, function () {
        var _a, id, status, interval_id, timestamp, timestamp_poll, _b, err, data;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _a = JSON.parse(localStorage.getItem(statusKey)), id = _a.id, status = _a.status, interval_id = _a.interval_id, timestamp = _a.timestamp, timestamp_poll = _a.timestamp_poll;
                    // Check progress
                    console.log('Checking status', " for id: ".concat(id));
                    return [4 /*yield*/, apis.sandbox.checkSandboxBackupResult(accessToken, id)];
                case 1:
                    _b = _c.sent(), err = _b[0], data = _b[1];
                    console.log(err, data);
                    if (!(err != null)) return [3 /*break*/, 2];
                    console.log(err);
                    backupFailed();
                    return [3 /*break*/, 4];
                case 2:
                    if (!(data.data.status == 'SUCCESS')) return [3 /*break*/, 4];
                    console.log("Request Successful for id :".concat(id));
                    return [4 /*yield*/, handleSuccess()];
                case 3:
                    _c.sent();
                    clearInterval(interval_id);
                    _c.label = 4;
                case 4:
                    console.log('check', timestamp_poll, Date.now(), backoff, Date.now() - timestamp_poll);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleSuccess = function () { return __awaiter(_this, void 0, void 0, function () {
        var result_status;
        return __generator(this, function (_a) {
            setIsRequestSuccess(true);
            setIsRequestDisabled(false);
            setIsRequestPending(false);
            result_status = JSON.parse(localStorage.getItem(statusKey));
            localStorage.setItem(statusKey, JSON.stringify(__assign(__assign({}, result_status), { status: 'SUCCESS' })));
            clearInterval(result_status.interval_id);
            setBackupsShouldUpdate(true);
            return [2 /*return*/];
        });
    }); };
    var updateBackupLinkStore = function (key, link) {
        var obj = {};
        obj[key] = link;
        var store = __assign(__assign({}, backupLinkStore), obj);
        localStorage.setItem(backupLinkStoreName, JSON.stringify(store));
        setBackupLinkStore(store);
        setBackupsShouldUpdate(true);
    };
    var getPresignedURL = function (backupObj) { return __awaiter(_this, void 0, void 0, function () {
        var key, _a, err, data, downloadUrl;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    key = backupObj.key;
                    return [4 /*yield*/, apis.sandbox.requestSandboxBackupLink(accessToken, sandboxHashKey, key)];
                case 1:
                    _a = _b.sent(), err = _a[0], data = _a[1];
                    console.log(err, data);
                    downloadUrl = data.data.downloadUrl;
                    updateBackupLinkStore(key, downloadUrl);
                    return [2 /*return*/];
            }
        });
    }); };
    var backupFailed = function () { return __awaiter(_this, void 0, void 0, function () {
        var result_status;
        return __generator(this, function (_a) {
            setIsRequestDisabled(false);
            setIsRequestPending(false);
            setDidRequestFail(true);
            result_status = JSON.parse(localStorage.getItem(statusKey));
            localStorage.setItem(statusKey, JSON.stringify(__assign(__assign({}, result_status), { status: 'FAILED' })));
            clearInterval(result_status.interval_id);
            console.log('Backup Failed');
            return [2 /*return*/];
        });
    }); };
    var requestBackup = function () { return __awaiter(_this, void 0, void 0, function () {
        var _a, err, data, _b, id, status, interval_id;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    setIsRequestDisabled(true);
                    if (didRequestFail == true)
                        setDidRequestFail(false);
                    window.neo4jSandbox.tracking.event('SANDBOX_BACKUP_REQUEST', { "key": sandboxHashKey });
                    return [4 /*yield*/, apis.sandbox.requestSandboxBackup(accessToken, sandboxHashKey)];
                case 1:
                    _a = _c.sent(), err = _a[0], data = _a[1];
                    _b = data.data.result, id = _b.id, status = _b.status;
                    if (status == 'PENDING') {
                        setIsRequestPending(true);
                        interval_id = setInterval(checkProgress, 4000);
                        localStorage.setItem(statusKey, JSON.stringify({
                            id: id,
                            status: status,
                            interval_id: interval_id,
                            timestamp: Date.now(),
                            timestamp_poll: Date.now(),
                        }));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var RequestButton = function () {
        return (React.createElement(Button, { basic: true, icon: React.createElement(BackupIcon, { color: styleConstants.colors.charcoal, size: 14, viewBox: undefined }), className: isRequestDisabled ? 'font-regular disabled' : 'font-regular', onClick: requestBackup }, "Request Backup"));
    };
    var getLocalLink = function (row) {
        if (row.key in backupLinkStore) {
            return backupLinkStore[row.key];
        }
        return null;
    };
    var BackupRow = function (row, index) {
        var backup_date = new Date(row.LastModified);
        var backup_date_utc = backup_date.toUTCString();
        var backup_date_locale = backup_date.toLocaleString();
        var localLink = getLocalLink(row);
        var localLinkExists = !!localLink;
        console.log('localLink - ', localLink);
        return (React.createElement(Grid.Column, { width: 16, className: "border-bottom sandbox-extend-grid" },
            React.createElement("div", { className: "pull-right" }, localLinkExists ? (React.createElement(Button, { basic: true, className: "font-regular", icon: React.createElement(DownloadIcon, { color: styleConstants.colors.charcoal, size: 18 }), size: "small", href: localLink }, "Download")) : (React.createElement(Button, { basic: true, className: "font-regular", icon: React.createElement(DownloadIcon, { color: styleConstants.colors.charcoal, size: 18 }), size: "small", onClick: function () { return getPresignedURL(row); } }, "Request DownloadLink"))),
            React.createElement("p", { className: "mb1 font-small" },
                "Sandbox Dump - ",
                backup_date_locale),
            React.createElement("p", { className: "font-small color-aluminum" }, backup_date_utc)));
    };
    var PendingRequests = function () {
        return (React.createElement(Grid.Column, { width: 16, className: "border-bottom sandbox-extend-grid" },
            React.createElement("p", { className: "mb1 font-small" }, "Sandbox Requested"),
            React.createElement("p", { className: "font-small color-aluminum" },
                React.createElement(Progress, { percent: 100, active: true, indicating: true }, "Request is pending"))));
    };
    var FailedRequests = function () {
        return (React.createElement(Grid.Column, { width: 16, className: "border-bottom sandbox-extend-grid" },
            React.createElement("p", { className: "mb1 font-small" }, "Sandbox Requested"),
            React.createElement("p", { className: "font-small color-aluminum" },
                React.createElement(Progress, { percent: 100, error: true }, "There was an issue generating the dump file."))));
    };
    // const SuccessfulRequests = () => {
    //         return ( <Grid.Column width={16} className="border-bottom sandbox-extend-grid">
    //         <p className="mb1 font-small">Sandbox Requested</p>
    //         <p className="font-small color-aluminum">
    //         <Progress percent={100} active indicating>
    //          Request is pending
    //         </Progress>
    //         </p>
    //     </Grid.Column>
    //         )
    // }
    return (React.createElement("div", null,
        React.createElement(Grid, null,
            React.createElement(Grid.Column, { width: 16, className: "border-bottom sandbox-extended-grid" },
                React.createElement("div", { className: "pull-right" },
                    React.createElement("div", { style: { cursor: 'pointer' } },
                        React.createElement(RequestButton, null)))),
            didRequestFail ? FailedRequests() : React.createElement("br", null),
            isRequestPending ? PendingRequests() : React.createElement("br", null),
            backupList)));
};
// export default SandboxBackups
var mapDispatchToProps = function (dispatch) { return ({
    showActionModal: function (data) { return dispatch(showModal(data)); },
}); };
var mapStateToProps = function (state) { return ({
    accessToken: state.user.accessToken,
}); };
export default connect(mapStateToProps, mapDispatchToProps)(SandboxBackups);
